import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { BreadcrumbModel } from '../../breadcrumbs/breadcrumb.models';
import { BreadcrumbsResolve } from '../../breadcrumbs/breadcrumbs.resolver';
import { CompetitionRouteService } from '../../competition-list/competition-route.service';
import type { TournamentFixtureList } from '../../event-list-shared/tournament/tournament.service';

@Injectable({ providedIn: 'root' })
export class TournamentLeagueBreadcrumbsResolver extends BreadcrumbsResolve<TournamentFixtureList | undefined> {
    constructor(
        private sitecore: Sitecore,
        private urlHelper: UrlHelperService,
        private route: CompetitionRouteService,
    ) {
        super();
    }

    protected customResolve(model: TournamentFixtureList | undefined): BreadcrumbModel[] {
        if (!model || !model.tournament) {
            return [];
        }

        const params = this.route.params();
        const tournament = model.tournament;
        const sport = tournament.sport;
        const league = tournament.leagues.find((current) => current.id.live === params.league || current.id.preMatch === params.league);

        if (!league) {
            return [];
        }

        const messages = this.sitecore.globalMessages;
        const title = this.sitecore.seo.SportBreadcrumbTitle.replace(/{{sport}}/, sport.name);

        return [
            this.createCrumb({
                icon: `sports-${sport.id}`,
                title,
                url: this.urlHelper.getSportUrl(sport),
            }),
            this.createCrumb({
                icon: 'sports-globe',
                title: messages.Competitions,
                url: this.urlHelper.getSportUrl(sport, SportUrlParam.Betting, SportUrlParam.Competitions),
            }),
            this.createCrumb({
                icon: 'sports-tournament',
                title: tournament.name,
                url: this.urlHelper.getTournamentUrl(sport, tournament.id),
            }),
            this.createCrumb({
                icon: 'sports-league',
                title: league.name,
                url: this.urlHelper.getTournamentUrl(sport, tournament.id, { id: league.id.live || league.id.preMatch, name: league.name }),
            }),
        ];
    }
}
